// Import model
import { StartRoomSelectionAddFreightRequest } from '../models/StartRoomSelectionAddFreightRequest';

// Import base class serializer

// Import dependency types (models and enums used in properties)

// Import dependency serializers (for complex types)

// Import derived type serializers (for polymorphic deserialization)

/**
 * Serializer for StartRoomSelectionAddFreightRequest - handles JSON serialization and deserialization with type validation
 */
export class StartRoomSelectionAddFreightRequestSerializer {
  /**
   * Deserializes a JSON string into a StartRoomSelectionAddFreightRequest instance
   */
  static deserialize(json: string): StartRoomSelectionAddFreightRequest {
    const obj = JSON.parse(json);
    return this.fromObject(obj);
  }

  /**
   * Deserializes a plain object into a StartRoomSelectionAddFreightRequest instance
   */
  static fromObject(obj: any): StartRoomSelectionAddFreightRequest {
    if (!obj) {
      throw new Error('Cannot deserialize null or undefined to StartRoomSelectionAddFreightRequest');
    }


    const instance: StartRoomSelectionAddFreightRequest = {
      itemId: obj['itemId'] as string | undefined,
    };

    return instance;
  }

  /**
   * Deserializes a JSON string into an array of StartRoomSelectionAddFreightRequest instances
   */
  static deserializeArray(json: string): StartRoomSelectionAddFreightRequest[] {
    const arr = JSON.parse(json);
    if (!Array.isArray(arr)) {
      throw new Error('Expected JSON array');
    }
    return arr.map(obj => this.fromObject(obj));
  }

  /**
   * Serializes a StartRoomSelectionAddFreightRequest instance to a JSON string
   */
  static serialize(instance: StartRoomSelectionAddFreightRequest): string {
    return JSON.stringify(this.toObject(instance));
  }

  /**
   * Converts a StartRoomSelectionAddFreightRequest instance to a plain object
   */
  static toObject(instance: StartRoomSelectionAddFreightRequest): any {
    return {
      'itemId': instance.itemId,
    };
  }

  /**
   * Serializes an array of StartRoomSelectionAddFreightRequest instances to a JSON string
   */
  static serializeArray(instances: StartRoomSelectionAddFreightRequest[]): string {
    return JSON.stringify(instances.map(inst => this.toObject(inst)));
  }
}
